export default function (url: string): {
  query: any
} {
  const queryStr: string = url.split('#')[0].split('?')[1];
  const query: object = {};
  (queryStr ? queryStr.split('&') : []).forEach((v) => {
    const arr: string[] = v.split('=');
    const key: string = arr[0];
    let val: (string | number) = arr[1];
    if (!isNaN(Number(val))) val = Number(val);
    query[key] = val;
  });
  return {
    query: query
  };
}
